import request from '@/utils/request'

let InspectionApi = {

  /*隐患排查检查项列表*/
  list(data) {
    return request._post('/shop/plus.inspection.Index/index', data);
},
/*添加隐患排查检查项*/
add(data) {
    return request._post('/shop/plus.inspection.Index/add', data);
},
/*修改隐患排查检查项*/
edit(data) {
    return request._post('/shop/plus.inspection.Index/edit', data);
},
/*删除隐患排查检查项*/
del(data) {
    return request._post('/shop/plus.inspection.Index/del', data);
},
/*隐患排查检查项详情*/
detail(data) {
  return request._post('/shop/plus.inspection.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.inspection.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.inspection.Setting/getSetting', data, errorback);
    },
}
export default InspectionApi;



// WEBPACK FOOTER //
// ./src/api/inspection.js